/* ==========================================================================
   TRE EMME — CX product page: variants, colours, add to cart, sticky bar,
   gallery counter, zoom, recommendations.
   ========================================================================== */
document.addEventListener('DOMContentLoaded', () => {
  'use strict';
  const pdp = document.querySelector('[data-cx-pdp]');
  if (!pdp || !window.CX) return;
  const { $, $$, toast, money, reduceMotion, watchImages } = window.CX;

  const read = (sel) => { try { return JSON.parse($(sel, pdp).textContent); } catch (e) { return null; } };
  const variants = read('[data-cx-variants]') || [];
  const config = read('[data-cx-pdp-config]') || {};
  const form = $('.cx-pdp__form', pdp);
  const idInput = $('[data-cx-variant-id]', pdp);
  const addBtn = $('[data-cx-add]', pdp);
  const addLabel = $('[data-cx-add-label]', pdp);
  const optionSets = $$('[data-cx-option]', pdp);
  const behavior = reduceMotion.matches ? 'auto' : 'smooth';

  /* Fixed layers live in <body> so no ancestor can trap them under the page */
  const sticky = $('[data-cx-sticky]', pdp);
  const zoom = document.getElementById('cx-zoom');
  const guide = document.getElementById('cx-sizeguide');
  const garan = document.getElementById('cx-garan');
  [sticky, zoom, guide, garan].forEach((el) => { if (el && el.parentElement !== document.body) document.body.appendChild(el); });

  /* Reviews accordion: Reputon's widget.js only once it is opened */
  $$('[data-cx-reviews-src]', pdp).forEach((acc) => acc.addEventListener('toggle', () => {
    if (!acc.open || acc.dataset.cxLoaded) return;
    acc.dataset.cxLoaded = '1';
    const s = document.createElement('script');
    s.src = acc.dataset.cxReviewsSrc;
    s.defer = true;
    document.body.appendChild(s);
  }));

  /* Back */
  $$('[data-cx-back]', pdp).forEach((a) => a.addEventListener('click', (e) => {
    if (document.referrer && new URL(document.referrer).origin === location.origin && history.length > 1) {
      e.preventDefault();
      history.back();
    }
  }));

  /* Variants */
  const selected = () => optionSets.map((set) => {
    const input = $('input:checked', set);
    return input ? input.value : null;
  });

  const findVariant = (opts) => variants.find((v) => v.options.every((o, i) => opts[i] === o));
  let current = null;

  const setStock = (v) => {
    const text = $('[data-cx-stock-text]', pdp);
    const bar = $('[data-cx-stock-bar]', pdp);
    const box = $('[data-cx-stock]', pdp);
    if (!text) return;
    let label = 'Disponibile';
    let pct = 100;
    let state = 'ok';
    // Availability is per size: stay hidden until a full variant is chosen (the add button already says "Esaurito" when nothing is left)
    // Sold-out size: no stock bar either, the bell + Back in Stock form say it already
    box.hidden = !v || !v.available;
    if (!v || !v.available) { delete box.dataset.state; return; }
    if (!v.available) {
      // One-size products and fully sold-out products read "Esaurito", not "size sold out"
      const allOut = config.hasSingle || !variants.some((x) => x.available);
      label = allOut ? 'Esaurito' : 'Taglia esaurita'; pct = 0; state = 'out';
    } else if (v.qty !== null && v.qty <= 3) {
      label = v.qty === 1 ? 'Ultimo pezzo disponibile' : `Ultimi ${v.qty} pezzi`; pct = v.qty * 20; state = 'low';
    }
    text.textContent = label;
    box.dataset.state = state;
    bar && bar.style.setProperty('--w', `${pct}%`);
  };

  // Back in stock: the "notify me" box follows the selected size (always on when the whole product is sold out)
  const syncNotify = (v) => {
    const box = document.getElementById('cx-notify');
    if (!box || !box.querySelector('form')) return;
    const allOut = !variants.some((x) => x.available);
    box.hidden = !(allOut || (v && !v.available));
    const sel = box.querySelector('#cx-notify-size');
    if (sel && v) {
      const opt = Array.from(sel.options).find((o) => o.dataset.variant === String(v.id));
      if (opt) sel.value = opt.value;
    }
    const hiddenVariant = box.querySelector('[data-cx-notify-variant]');
    if (hiddenVariant && v) hiddenVariant.value = v.id;
  };

  // Back in Stock app (sw-back-in-stock, same as the live theme). On a sold-out size its request form (email + Avvisami)
  // takes the place of the add-to-cart button, inline: the app's dialog element is moved under the sizes and shown
  // there (CSS drops the overlay). Its own inline button stays hidden; the bell on the size is the cue.
  const restockSlot = document.createElement('div');
  restockSlot.className = 'cx-pdp__restock';
  restockSlot.hidden = true;
  const actionsBox = addBtn && addBtn.closest('.cx-pdp__actions');
  actionsBox && actionsBox.after(restockSlot);
  const restockTrigger = () => document.querySelector('.product-restore-email .email-me-button') || document.querySelector('.product-restore-email');
  const showRestock = (on, focus) => {
    const trigger = restockTrigger();
    if (!trigger) return false;
    restockSlot.hidden = !on;
    if (!on) {
      const frame = document.getElementById('email-me-frame');
      if (frame) frame.style.display = 'none';
      return true;
    }
    setTimeout(() => {
      trigger.click(); // the app fills its form for the selected size and shows it
      const frame = document.getElementById('email-me-frame');
      if (!frame) return;
      if (frame.parentElement !== restockSlot) restockSlot.appendChild(frame);
      const title = frame.querySelector('.frame-title');
      const picked = document.querySelector('.cx-pdp__size.is-out input:checked');
      if (title && picked) title.setAttribute('data-size', picked.value);
      const email = frame.querySelector('.buyer-email');
      if (focus && email) email.focus({ preventScroll: true });
    }, 150); // let the app read the new variant first
    return true;
  };

  const render = (v, initial = false) => {
    current = v || null;
    const opts = selected();
    // Disable values that cannot complete an available variant with the other choices
    optionSets.forEach((set, i) => {
      $$('input', set).forEach((input) => {
        const ok = variants.some((x) => x.available
          && x.options.every((o, j) => (j === i ? o === input.value : opts[j] === null || opts[j] === o)));
        input.closest('.cx-pdp__size').classList.toggle('is-out', !ok);
      });
      const val = $('[data-cx-option-value]', set);
      if (val) val.textContent = opts[i] ? `: ${opts[i]}` : '';
    });

    if (v) {
      idInput.value = v.id;
      const amount = $('[data-cx-amount]', pdp);
      const compare = $('[data-cx-compare]', pdp);
      const badge = $('[data-cx-discount]', pdp);
      amount && (amount.textContent = money(v.price));
      const onSale = v.compare > v.price;
      if (compare) { compare.hidden = !onSale; compare.textContent = onSale ? money(v.compare) : ''; }
      if (badge) { badge.hidden = !onSale; badge.textContent = onSale ? `-${Math.round((v.compare - v.price) / v.compare * 100)}%` : ''; }
      const stickyPrice = sticky && $('[data-cx-sticky-price]', sticky);
      stickyPrice && (stickyPrice.textContent = money(v.price));
      const stickyCompare = sticky && $('[data-cx-sticky-compare]', sticky);
      if (stickyCompare) { stickyCompare.hidden = !onSale; stickyCompare.textContent = onSale ? money(v.compare) : ''; }
      if (!initial) {
        const url = new URL(location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url);
      }
    }
    if (addBtn) {
      const soldOut = !variants.some((x) => x.available);
      const needSize = !soldOut && !v && optionSets.length > 0;
      addBtn.disabled = soldOut || (!!v && !v.available);
      addBtn.classList.toggle('is-pending', needSize);
      addLabel.textContent = soldOut || (v && !v.available) ? 'Esaurito' : 'Aggiungi al carrello';
    }
    // sold-out size: the inline request form replaces the add-to-cart button (when the app is on the page)
    const restock = !!v && !v.available && showRestock(true, !initial);
    if (!restock) showRestock(false);
    if (actionsBox) actionsBox.hidden = restock || (actionsBox.dataset.soldout === 'true');
    const stickyLabel = sticky && $('[data-cx-sticky-add] span', sticky);
    if (stickyLabel) stickyLabel.textContent = v && !v.available ? 'Avvisami' : 'Quick add';
    setStock(v);
    syncNotify(v);
    const dynamic = $('.cx-pdp__dynamic', pdp);
    if (dynamic) dynamic.hidden = !v || !v.available; // express checkout only on a chosen, available size
  };

  optionSets.forEach((set) => set.addEventListener('change', () => {
    const opts = selected();
    render(opts.every((o) => o !== null) ? findVariant(opts) : null);
  }));
  {
    const opts = selected();
    render(config.hasSingle ? variants[0] : (opts.every((o) => o !== null) ? findVariant(opts) : null), true);
  }

  const flashSizes = () => {
    const set = optionSets.find((s) => !$('input:checked', s)) || optionSets[0];
    if (!set) return;
    set.scrollIntoView({ behavior, block: 'center' });
    set.classList.remove('is-flash');
    void set.offsetWidth;
    set.classList.add('is-flash');
    const first = $('.cx-pdp__size:not(.is-out) input', set);
    first && first.focus({ preventScroll: true });
  };

  /* Add to cart */
  if (form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      if (!current) { flashSizes(); toast('Seleziona una taglia'); return; }
      if (!current.available) { showRestock(true, true); return; }
      addBtn.classList.add('is-loading');
      const items = [{ id: current.id, quantity: 1 }];
      const add = window.CX.cartAdd(items);
      add.then((res) => {
        addBtn.classList.remove('is-loading');
        if (!res) return;
        addBtn.classList.add('is-done');
        addLabel.textContent = 'Aggiunto al carrello';
        setTimeout(() => { addBtn.classList.remove('is-done'); render(current, true); }, 1800);
      }).catch(() => { addBtn.classList.remove('is-loading'); toast('Impossibile aggiungere il prodotto.', { type: 'error' }); });
    });
  }

  /* Sticky quick add */
  if (sticky && addBtn) {
    // Shown once the main add button has scrolled above the viewport (one rect read per scroll)
    const stickyAdd = $('[data-cx-sticky-add]', sticky);
    let shown = null;
    const updateSticky = () => {
      const show = addBtn.getBoundingClientRect().bottom < 0;
      if (show === shown) return;
      shown = show;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', String(!show));
      stickyAdd.tabIndex = show ? 0 : -1;
    };
    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', updateSticky, { passive: true });
    updateSticky();
    // Size picker in the bar: a native select mirroring the size buttons of the page (sold-out sizes marked), so
    // Quick add never fires without a size — with none chosen it opens the picker instead
    const sizeSet = optionSets.find((set) => set.querySelector('.cx-pdp__guide')) || optionSets[optionSets.length - 1];
    const sizeInputs = sizeSet ? $$('input', sizeSet) : [];
    let stickySize = null;
    if (sizeInputs.length > 1) {
      stickySize = document.createElement('select');
      stickySize.className = 'cx-pdp__sticky-size';
      stickySize.setAttribute('aria-label', 'Taglia');
      stickySize.tabIndex = -1;
      stickyAdd.before(stickySize);
      const fill = () => {
        const picked = sizeInputs.find((i) => i.checked);
        stickySize.innerHTML = `<option value="" disabled${picked ? '' : ' selected'}>Taglia</option>` + sizeInputs.map((i) => {
          const out = i.closest('.cx-pdp__size').classList.contains('is-out');
          return `<option value="${i.value.replace(/"/g, '&quot;')}"${i.checked ? ' selected' : ''}>${i.value}${out ? ' · esaurita' : ''}</option>`;
        }).join('');
      };
      fill();
      sizeSet.addEventListener('change', fill);
      optionSets.forEach((set) => set !== sizeSet && set.addEventListener('change', () => setTimeout(fill)));
      stickySize.addEventListener('change', () => {
        const input = sizeInputs.find((i) => i.value === stickySize.value);
        if (input && !input.checked) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
      });
    }
    const showStickyExtras = () => { if (stickySize) stickySize.tabIndex = shown ? 0 : -1; };
    window.addEventListener('scroll', showStickyExtras, { passive: true });
    stickyAdd.addEventListener('click', () => {
      if (!current) {
        if (stickySize) {
          stickySize.focus();
          try { stickySize.showPicker(); } catch (err) { /* older browsers: focus is the cue */ }
          stickySize.classList.remove('is-flash'); void stickySize.offsetWidth; stickySize.classList.add('is-flash');
        } else flashSizes();
        return;
      }
      if (!current.available) {
        // sold-out size: the request form sits where the add button was
        restockSlot.scrollIntoView({ behavior, block: 'center' });
        const email = restockSlot.querySelector('.buyer-email');
        email && setTimeout(() => email.focus({ preventScroll: true }), 300);
        return;
      }
      form.requestSubmit ? form.requestSubmit() : addBtn.click();
    });
  }

  /* Sold out — Klaviyo Back in Stock (when enabled in the section): subscribe the email to the chosen size's variant.
     Any failure falls back to the plain contact form, so the request is never lost. */
  const notify = document.getElementById('cx-notify');
  const notifyForm = notify && $('form', notify);
  if (notifyForm && notify.dataset.klaviyoCompany) {
    notifyForm.addEventListener('submit', (e) => {
      if (notifyForm.dataset.fallback) return; // second pass: let the contact form post
      const email = (notifyForm.querySelector('[type="email"]') || {}).value || '';
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email.trim())) return; // native validation / contact form shows the error
      e.preventDefault();
      const sizeSel = $('#cx-notify-size', notifyForm);
      const variantId = sizeSel ? sizeSel.selectedOptions[0].dataset.variant : ($('[data-cx-notify-variant]', notifyForm) || {}).value;
      const btn = $('[type="submit"]', notifyForm);
      btn.disabled = true;
      fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${encodeURIComponent(notify.dataset.klaviyoCompany)}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
        body: JSON.stringify({ data: { type: 'back-in-stock-subscription', attributes: {
          channels: ['EMAIL'],
          profile: { data: { type: 'profile', attributes: { email: email.trim() } } },
        }, relationships: { variant: { data: { type: 'catalog-variant', id: `$shopify:::$default:::${variantId}` } } } } }),
      }).then((r) => {
        if (!r.ok) throw new Error(String(r.status));
        notifyForm.innerHTML = '<div role="status"><p class="cx-pdp__notify-title" tabindex="-1">Richiesta ricevuta</p><p class="cx-text cx-muted">Ti scriviamo appena torna disponibile.</p></div>';
        $('.cx-pdp__notify-title', notifyForm).focus({ preventScroll: true });
      }).catch(() => {
        notifyForm.dataset.fallback = '1';
        btn.disabled = false;
        notifyForm.requestSubmit ? notifyForm.requestSubmit() : notifyForm.submit();
      });
    });
  }

  /* Info column, Gymshark-style (desktop): the page is the only scroller. The column's sticky top follows the scroll:
     down, it rises until the column's end is on screen and holds there; up, it comes back down until it sits under the
     breadcrumb bar again. So a long column is fully readable and is back at its top together with the gallery. */
  const info = $('.cx-pdp__info', pdp);
  const hud = document.querySelector('.cx-pdp__hud');
  const desk = window.matchMedia('(min-width: 768px)');
  if (info && hud) {
    let top = null;
    let lastY = window.scrollY;
    let queued = false;
    // where the breadcrumb bar ends while stuck (its own top animates when the header hides)
    const edge = () => (parseFloat(getComputedStyle(hud).top) || 0) + hud.offsetHeight;
    const place = () => {
      queued = false;
      if (!desk.matches) { info.classList.remove('is-tracked'); info.style.top = ''; top = null; return; }
      const y = window.scrollY;
      const dy = y - lastY;
      lastY = y;
      const max = edge();
      const min = Math.min(max, window.innerHeight - info.offsetHeight - 12);
      top = top === null ? max : Math.max(min, Math.min(max, top - dy));
      info.style.top = `${top}px`;
      info.classList.add('is-tracked');
    };
    const queue = () => { if (!queued) { queued = true; requestAnimationFrame(place); } };
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    desk.addEventListener('change', queue);
    if ('ResizeObserver' in window) new ResizeObserver(queue).observe(info); // accordions, size guide
    // follow the bar while the header slides in or out
    const header = document.querySelector('[data-cx-header]');
    if (header) {
      new MutationObserver(() => {
        const until = performance.now() + 450;
        const follow = () => { place(); if (performance.now() < until) requestAnimationFrame(follow); };
        requestAnimationFrame(follow);
      }).observe(header, { attributes: true, attributeFilter: ['class'] });
    }
    place();
  }

  /* Gallery counter (mobile swipe) */
  const track = $('[data-cx-gallery-track]', pdp);
  const indexEl = $('[data-cx-gallery-index]', pdp);
  if (track && indexEl) {
    track.addEventListener('scroll', () => requestAnimationFrame(() => {
      const w = track.clientWidth || 1;
      indexEl.textContent = String(Math.round(track.scrollLeft / w) + 1);
    }), { passive: true });
  }

  /* Zoom: scroll the overlay to the clicked image */
  pdp.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-cx-zoom-index]');
    if (!btn) return;
    const i = Number(btn.dataset.cxZoomIndex);
    setTimeout(() => {
      const target = zoom && $$('.cx-zoom__list li', zoom)[i];
      target && target.scrollIntoView({ block: 'start' });
    }, 30);
  });

  /* Colours: Tre Emme's colour variants are separate products sharing the model_code: tag (and vendor, gender) */
  const colors = $('[data-cx-colors]', pdp);
  const modelTag = pdp.dataset.modelCode;
  if (colors && modelTag) {
    const q = encodeURIComponent(`(tag:'${modelTag}')`);
    fetch(`/search/suggest.json?q=${q}&resources[type]=product&resources[limit]=10&resources[options][fields]=tag&resources[options][unavailable_products]=last`)
      .then((r) => r.json())
      .then((data) => {
        const vendor = (pdp.dataset.vendor || '').toLowerCase();
        const handle = pdp.dataset.productHandle;
        const gender = (pdp.dataset.gender || '').toLowerCase();
        const tagValue = (p, key) => {
          const t = (p.tags || []).map((x) => String(x)).find((x) => x.toLowerCase().startsWith(`${key}:`));
          return t ? t.slice(key.length + 1).trim() : '';
        };
        // Only siblings for the same gender (or unisex / untagged)
        const sameGender = (p) => {
          if (gender !== 'uomo' && gender !== 'donna') return true;
          const g = tagValue(p, 'gender').toLowerCase();
          return !g || g === gender || tagValue(p, 'special_gender').toLowerCase() === 'unisex';
        };
        const items = ((data.resources && data.resources.results && data.resources.results.products) || [])
          .filter((p) => p.handle !== handle && (p.vendor || '').toLowerCase() === vendor
            && (!p.tags || p.tags.includes(modelTag)) && sameGender(p));
        if (!items.length) return;
        const list = $('[data-cx-colors-list]', colors);
        items.forEach((p) => {
          const name = tagValue(p, 'micro_color') || p.title;
          const li = document.createElement('li');
          const img = p.featured_image && p.featured_image.url ? `<img src="${p.featured_image.url}${p.featured_image.url.includes('?') ? '&' : '?'}width=160" alt="" loading="lazy">` : '';
          li.innerHTML = `<a class="cx-pdp__swatch${p.available ? '' : ' is-out'}" href="${p.url.split('?')[0]}">${img}<span class="cx-sr">Colore ${name}</span></a>`;
          list.appendChild(li);
        });
        colors.hidden = false;
        // The sticky quick add repeats the colour thumbnails (Figma), linking to the sibling products
        const thumbs = sticky && $('[data-cx-sticky-thumbs]', sticky);
        thumbs && items.slice(0, 5).forEach((p) => {
          if (!p.featured_image || !p.featured_image.url) return;
          const a = document.createElement('a');
          a.className = 'cx-pdp__sticky-thumb';
          a.href = p.url.split('?')[0];
          a.tabIndex = -1;
          const img = document.createElement('img');
          img.src = `${p.featured_image.url}${p.featured_image.url.includes('?') ? '&' : '?'}width=80`;
          img.alt = '';
          img.loading = 'lazy';
          const label = document.createElement('span');
          label.className = 'cx-sr';
          label.textContent = p.title; // titles come from the catalogue sync: never as HTML
          a.append(img, label);
          thumbs.appendChild(a);
        });
      })
      .catch(() => {});
  }

  /* Recommendations — only the product's season (data-season); topped up from the same-season pool of its category */
  const recs = document.querySelector('[data-cx-recs]');
  if (recs && recs.dataset.url && !recs.querySelector('[data-cx-track]')) {
    const season = recs.dataset.season;
    const pool = recs.querySelector('template[data-cx-recs-pool]');
    fetch(recs.dataset.url)
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const next = doc.querySelector('[data-cx-recs]');
        const track = next && next.querySelector('[data-cx-track]');
        if (!track) { recs.remove(); return; }
        if (season) {
          track.querySelectorAll('.cx-rail__item').forEach((item) => { if (item.dataset.season !== season) item.remove(); });
          if (pool) {
            const seen = new Set(Array.from(track.children, (item) => item.dataset.handle));
            Array.from(pool.content.children).forEach((item) => {
              if (track.children.length >= 12 || seen.has(item.dataset.handle)) return;
              seen.add(item.dataset.handle);
              track.append(document.importNode(item, true));
            });
          }
        }
        if (!track.children.length) { recs.remove(); return; }
        recs.innerHTML = next.innerHTML;
        watchImages(recs);
        window.CX.initRail && window.CX.initRail(recs);
      })
      .catch(() => recs.remove());
  }
});
